import { useCallback, useState } from 'react';

const MAX_COHORT_NAME_LENGTH = 60;
const COPY_SUFFIX = ' copy';

/**
 * Get the initial cohort name with a copy suffix
 * If the name is too long, it will be truncated and the copy suffix will be added
 * @param name - The name of the cohort
 * @returns The initial cohort name with a copy suffix
 */
const getInitialCohortName = (name: string) => {
  if (name.length + COPY_SUFFIX.length > MAX_COHORT_NAME_LENGTH) {
    // If the name is too long, truncate it and add the copy suffix
    return `${name.slice(0, MAX_COHORT_NAME_LENGTH - COPY_SUFFIX.length)}${COPY_SUFFIX}`;
  }
  // If the name is not too long, add the copy suffix
  return `${name}${COPY_SUFFIX}`;
};

/**
 * Use the cohort name hook
 * @param cohortName - The name of the source cohort
 * @returns The cohort name and the handleCohortNameChange function
 */
export const useCohortName = (cohortName: string) => {
  const [newCohortName, setNewCohortName] = useState(getInitialCohortName(cohortName));

  const handleCohortNameChange = useCallback(
    (id: string, value: string, inError: boolean, errorCode: string, trimValue: string) => {
      setNewCohortName(value);
    },
    []
  );

  return {
    newCohortName,
    handleCohortNameChange,
  };
};
